import React from "react";
import { Container, Row, Col } from "reactstrap";
import "./Footer.css";

function Footer() {
  return (
    <footer>
      <Container fluid>
        <Row className="text-center py-1" style={{ background: 'linear-gradient(150deg,rgb(54, 122, 232) 0%,rgb(107, 150, 194) 100%)', color: "white" }}>
          <Col>
            <p className="p-0 m-0">
              Copyright © 2025 HKRNL.{" "}
              <span style={{ fontSize: "0.7rem" }}>All Rights Reserved. </span>
              <span style={{ fontSize: "0.7rem" }}>
                <i>
                   Developed by{" "}
                  <a
                    href="https://hkcl.in/"
                    target="_blank"
                    style={{ fontSize: "0.7rem", color: "white" }}
                  >
                    <strong>HKCL</strong>
                  </a>
                </i>
              </span>
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
